module.exports = __webpack_public_path__ + "c227f335bb122b2cb936cd8d25789fc8.pdf";